import { useListView } from '../../core/ListViewProvider'
import { FinanceiroAtendimentosListSearchComponent } from './FinanceiroAtendimentosListSearchComponent'
import { UsersListGrouping } from './UsersListGrouping'

export const FinanceiroAtendimentosListHeader = () => {
  const { selected } = useListView()

  return (
    <div className='card-header border-0 pt-6'>
      <FinanceiroAtendimentosListSearchComponent
        actions={selected.length > 0 ? <UsersListGrouping /> : undefined}
      />
    </div>
  )
}
